/**
 * White Label Branding Configuration
 * 
 * This file centralizes all branding elements to support white labeling.
 * Modify this file to rebrand the application.
 */

const brandingConfig = {
  // Basic Information
  appName: "Taxi Pinneberg",
  companyName: "Taxi Pinneberg Tourenvermittlung UG (haftungsbeschränkt)",
  slogan: "Mit uns kommen Sie besser an!",

  // Contact Information
  email: "info@taxi-pi.de",
  phone: "+49 4101 772300",
  address: "Dingstätte 34, 25421 Pinneberg",
  owner: "Medt Avci, Flamur Sylejmani", // Pflicht für Impressum gemäß TMG § 5
  website: "https://taxi-pi.de",

  // Supervisory Authority (Aufsichtsbehörde für Personenbeförderung)
  // White-Label: An die örtliche Aufsichtsbehörde des Kunden anpassen!
  supervisoryAuthority: {
    name: "Kreis Pinneberg",
    department: "Fachdienst Straßenverkehr – Personenbeförderung",
    address: "Kurt-Wagener-Straße 11, 25337 Elmshorn",
  },

  // Data Protection Authority (Datenschutz-Aufsichtsbehörde)
  // White-Label: An das Bundesland des Kunden anpassen! (siehe BRANDING_VERBESSERUNGEN.md Abschnitt 6.4)
  dataProtectionAuthority: {
    name: "Unabhängiges Landeszentrum für Datenschutz Schleswig-Holstein (ULD)",
    address: "Holstenstraße 98, 24103 Kiel",
    phone: "0431 988-1200",
    website: "https://www.datenschutzzentrum.de",
  },

  // Legal Information
  copyright: `© ${new Date().getFullYear()} Taxi Pinneberg Tourenvermittlung UG (haftungsbeschränkt)`,

  // Colors
  colors: {
    primary: "#FFD600", // Taxi Yellow
    secondary: "#000000", // Black
    accent: "#FFA000", // Amber
    success: "#388E3C", // Green
    error: "#D32F2F", // Red
    warning: "#FF9800", // Orange
    info: "#2196F3", // Blue
    background: "#FFFFFF", // White
    text: {
      primary: "#333333", // Near Black
      secondary: "#757575", // Medium Gray
      light: "#FFFFFF", // White
    }
  },

  // Logos and Images
  // Taxi Pinneberg liefert nur ein kombiniertes Logo (Icon + Schriftzug in einer Grafik),
  // daher zeigen alle drei Slots auf dieselbe Datei (siehe LandingPage.js/Navbar.js: dort
  // wird deshalb nur noch ein Logo statt Icon+Primary gestapelt gerendert).
  logos: {
    primary: "/assets/TaxiPinneberg_Logo.png",
    icon: "/assets/TaxiPinneberg_Logo.png",
    favicon: "/favicon.ico",
    mobileLogo: "/assets/TaxiPinneberg_Logo.png",
  },
  
  // UI Elements
  ui: {
    borderRadius: "4px",
    buttonStyle: "rounded", // 'rounded', 'square', 'pill'
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
  },
  
  // Features Config
  features: {
    enableReports: true,
    enableLiveMap: true,
    enableShiftPlanning: true,
  },
  
  // Social Media
  socialMedia: {
    facebook: "",
    twitter: "",
    instagram: "",
  },
};

export default brandingConfig;